import firebase from 'firebase'
var config = {
    apiKey: "AIzaSyDh_vz3o5Ob1-EH0l7b2fZL2nVN2zR2lVA",
    authDomain: "pairful-app.firebaseapp.com",
    databaseURL: "https://pairful-app.firebaseio.com",
    projectId: "pairful-app",
    storageBucket: "pairful-app.appspot.com",
    messagingSenderId: "131998642107"
  };
var fire = firebase.initializeApp(config);
export default fire;


// WEBPACK FOOTER //
// ./src/fire.js